import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const TimerCtx = createContext(null);

export function TimerProvider({ children }) {
  const [timer, setTimer] = useState(null);
  const [elapsed, setElapsed] = useState(0);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/time/active");
      setTimer(data);
    } catch { /* non bloquant */ }
  }, []);

  useEffect(() => {
    reload();
    const t = setInterval(reload, 30000);
    return () => clearInterval(t);
  }, [reload]);

  useEffect(() => {
    if (!timer) { setElapsed(0); return; }
    const base = timer.accumulated_sec || 0;
    const resumeTs = timer.paused ? null : new Date(timer.last_resume_at).getTime();
    const tick = () => setElapsed(base + (resumeTs ? Math.max(0, Math.floor((Date.now() - resumeTs) / 1000)) : 0));
    tick();
    const i = setInterval(tick, 1000);
    return () => clearInterval(i);
  }, [timer]);

  const start = async (clientId, category, note) => {
    const { data } = await api.post("/time/start", { client_id: clientId, category, note });
    setTimer(data);
    return data;
  };
  const pause = async () => setTimer((await api.post("/time/pause")).data);
  const resume = async () => setTimer((await api.post("/time/resume")).data);
  const stop = async (category, note) => {
    const { data } = await api.post("/time/stop", { category, note });
    setTimer(null);
    window.dispatchEvent(new Event("sf:time"));
    return data;
  };

  return (
    <TimerCtx.Provider value={{ timer, elapsed, start, pause, resume, stop, reload }}>
      {children}
    </TimerCtx.Provider>
  );
}

export const useTimer = () => useContext(TimerCtx);
